import { createSlice } from "@reduxjs/toolkit";
import { STATUS } from "Components/Misc/CaseDetails_System";
import { setProp } from "Store/Actions";
import { setPropT } from 'Store/Actions/ts';
import setObj from "lodash/set";
import _ from "lodash";

export const initialData = {
    element: {},
    dataSet: {},
    callBack: {},
    validationDetails : {},
    sid: "",
    boq:[],
    actionNext: false,
    tabSelect: 'Full Solutions',
    reference_solution: {
        solution: "NDAC", 
        commercial_model: "Opex",
        contract_duration: 1, 
        ndacPlanner:{},
        linkedPlanner:{}
    },
    selected_ndac_services : [],
    finalCombined_ndac_services : [],
    elementMMS: {},
    undoBoq:[],
    pageFeedbacks:[],
    notification_messages:{},
    callbackdefaults : {},
    eot_response_syncoffer : [],
    setTargetFields: {},
    setAccessoriesButton: true,
    localStates : {
        setOptionsData: {},
        setOptionsDataList : {},
        setSearchButtonStatus : false,
        setIsLoading: false,
        setProdCatalogApiLoad : false,
        setProductDataList: {},
        setConsumptionGraph: false,
        subStepState: {},
    },
    dataFromPackage:{},
    modal:{},
    stepFormInputs:{},
    package_options_count : 0,
    intermediateConfigResponse : {},
    dynamicboqBakup: {},
    isCustomiseSaveDisabled : true
};
const dynamicSlice = createSlice({
    initialState: {
        data: initialData,
        status: STATUS.IDLE,
    },
    name: 'dynamic',
    reducers: {
        setElement(state, action) {
            state.data.element = action.payload
        },
        setArrayElement(state,action){
            if (action.payload.method === "add") {
                state.data.element[action.payload.activeStep][action.payload.useCase].push(action.payload.data);
            }
            if (action.payload.method === "remove") {
                state.data.element[action.payload.activeStep][action.payload.useCase] = state.data.element[action.payload.activeStep][action.payload.useCase].filter((e) => e.key !== action.payload.data.key);
            }
        },
        setCallBack(state,action){
            state.data.callBack = action.payload
        },
        resetDynamicStep(state,){
            state.data = {...initialData}
            state.status = STATUS.IDLE;
        },
        setQuantityList(state,action){
            state.data.element[action.payload.activeStep][action.payload.useCase][action.payload.selectName] = state.data.element[action.payload.activeStep][action.payload.useCase][action.payload.selectName].map((e) => e.id == action.payload.device.id ? action.payload.device : e);
        },
        setSelectedNdacServices(state, action){
            // console.log(action.payload, 'ndac payload')
            if(action.payload.method === "add"){
                const value = action.payload.data
                
                state.data.selected_ndac_services.push(value)
            }
        },
        setDataSet(state,action) {
            let newData = {...state.data.dataSet};
            for (let key in action.payload) {
                if((Object.keys(newData)).includes(key)) {
                    newData[key] = action.payload[key];
                }
            }
            if(action.payload.method === "remove"){
                state.data.selected_ndac_services = state.data.selected_ndac_services.filter((e) => e.product_id !== action.payload.data)
            }
        },
        // localstates used from options moved here
        setState(state,action) {
          state.data.localStates = action.payload;
        },

        setCount_of_data(state,action) {
            let newData = {...state.data.element};
            for (let step in action.payload) {
                if((Object.keys(newData)).includes(step)) {
                    for (let key in action.payload[step]) {
                        newData[step][key] = action.payload[step][key];
                    }
                }
            }
            state.data.element = {...newData};
        },

        // common function to dispatch batch data for dynamic slice
        setDynamicBatchData(state,action) {
            let newData = {...state.data[action.payload['slice']]};
            
            for (let eachKey in action.payload['data']) {
                if((Object.keys(newData)).includes(eachKey)) {
                    if(action.payload['data'][eachKey] === null) {
                        newData[eachKey] = null;
                    } else {
                        for (let key in action.payload['data'][eachKey]) {
                            newData[eachKey][key] = action.payload['data'][eachKey][key];
                        }
                    }
                }
            }
            state.data[action.payload['slice']] = {...newData};
        },
        
        updateElementDataOfStep(state,action) {
            const { stepName, stepData } = action.payload;
            state.data.element = {
                ...state.data.element,
                [stepName]: {
                ...state.data.element[stepName], // retain the other data in the step
                ...stepData // merge the updated step data
                }
            }
        },
         setStepConnectivityCategory(state, action) {
            state.data.element[action.payload.activeStep]["category"] = action.payload.category;
        },
        
        /**
         * Updates saleItems array in intermediateConfigResponse.responseData.boqData.data
         * @param {Object} action.payload - Contains action type and data
         * @param {string} action.payload.action - 'delete' or 'qtyChange'
         * @param {Object} action.payload.boQDeleteKey - Item to delete (for delete action)
         * @param {string} action.payload.productCode - Product code to find (for qtyChange action)
         * @param {number} action.payload.newQuantity - New quantity value (for qtyChange action)
         */
        updateSaleItemsInIntermediateResponse(state, action) {
            const { action: actionType, boQDeleteKey, productCode, newQuantity } = action.payload;
            
            // Check if intermediateConfigResponse and nested structure exists
            const intermediateResponse = state.data.intermediateConfigResponse as any;
            if (!intermediateResponse?.responseData?.boqData?.data?.saleItems) {
                return;
            }
            
            const saleItems = intermediateResponse.responseData.boqData.data.saleItems;
            
            if (actionType === 'delete' && boQDeleteKey) {
                // Add boQDeleteKey parameter as value to the saleItems array
                // This could mean either removing the item or marking it for deletion
                // Assuming we want to remove the item from the array
                intermediateResponse.responseData.boqData.data.saleItems = saleItems.filter(
                    (item: any) => item.productCode !== boQDeleteKey.product_id
                );
                
                // Alternatively, if you want to mark it for deletion instead of removing:
                // intermediateResponse.responseData.boqData.data.saleItems = saleItems.map(
                //     (item: any) => item.productCode === boQDeleteKey.product_id
                //         ? { ...item, boQDeleteKey: boQDeleteKey, customAction: 'deleted', quantity: 0 }
                //         : item
                // );
            }
            
            if (actionType === 'qtyChange' && productCode && newQuantity !== undefined) {
                // Find the saleItem object by 'productCode' and change quantity value
                intermediateResponse.responseData.boqData.data.saleItems = saleItems.map(
                    (item: any) => {
                        if (item.productCode === productCode) {
                            const updatedItem = { ...item, quantity: newQuantity };
                            // Update totalIRP = IRP * new qty
                            if (item.IRP !== undefined) {
                                updatedItem.totalIRP = item.IRP * newQuantity;
                            }
                            return updatedItem;
                        }
                        return item;
                    }
                );
            }

            if (_.isEmpty(state?.data?.dynamicboqBakup) || _.isEmpty(state?.data?.intermediateConfigResponse)) {
                state.data.isCustomiseSaveDisabled = true;
            } else {
                state.data.isCustomiseSaveDisabled = false;
            }
        },
        
        //  setRef(allRefs, item_id, value) {
        //     allRefs.current[item_id] = value;
        //   },
        
        // getRef(allRefs, item_id) {
        // return allRefs.current[item_id];
        // }
    },
    extraReducers(builder) {
        builder.addCase(setProp, (state, action: setPropT) => {
            if (action.payload.slice === dynamicSlice.name) {
                setObj(state.data, action.payload.key, action.payload.value);
            }
        })
    }
});

export default dynamicSlice.reducer;
export const {setElement, setArrayElement, setCallBack, resetDynamicStep,setQuantityList, setSelectedNdacServices,setDataSet,setCount_of_data,updateElementDataOfStep,setDynamicBatchData,setStepConnectivityCategory,updateSaleItemsInIntermediateResponse } = dynamicSlice.actions;
